import BackendService from 'BackendService';

/**
 * Advisor-specific backend that routes via /api/advisor/*
 * Only overrides URL builder; inherits all methods from BackendService.
 */
export default class AdvisorBackendService extends BackendService {
  public apiURL(path: string): string {
    const trimmed = path.startsWith('/') ? path.slice(1) : path;
    return `/api/advisor/${trimmed}`;
  }
}
